import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getTechnicians,
  getCurrentPageTechnicians,
  getPerPageTechnicians,
  getTotalTechnicians,
  getActiveTab,
} from 'selectors/admin/team/contractor-team';
import {
  loadTechnicianFormRequest,
  setCurrentTechnicianId,
  setShowInviteTechnicianModal,
  loadTechnicianRequest,
  setCurrentPageTechnicians,
} from 'actions/admin/team/contractor-team';
import SimpleTable from 'components/shared/table/SimpleTable';
import { formatPhoneNumber } from 'services/utils/text-util';
import { UserModalState } from 'components/shared/modal/InviteUserModal';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import './ContractorTeam.css';
import { usersApi } from 'services/api/users-api';
import { getCurrentUser } from 'selectors/authentication';

const TechniciansTableHeaders = ['NAME', 'EMAIL', 'PHONE NUMBER', 'ACTIONS'];

class TechniciansTable extends Component {
  render() {
    const {
      technicians,
      currentPageTechnicians,
      perPageTechnicians,
      totalTechnicians,
    } = this.props;
    return (
      <React.Fragment>
        <SimpleTable
          headers={TechniciansTableHeaders}
          rows={this.mapTechnicians(technicians)}
          emptyMessage={'No Technicians'}
        />
        <div className="pagination-container">
          <SimplePagination
            currentPage={currentPageTechnicians}
            pageSize={perPageTechnicians}
            total={totalTechnicians}
            onPageChange={this.handlePageChange}
          />
        </div>
      </React.Fragment>
    );
  }

  handlePageChange = (newPage) => {
    const { dispatch, activeTab } = this.props;
    dispatch(loadTechnicianRequest(newPage, activeTab));
    dispatch(setCurrentPageTechnicians(newPage));
  };

  handleSelectUser = (user) => {
    this.props.dispatch(setCurrentTechnicianId(user.id));
    this.props.dispatch(loadTechnicianFormRequest(user));
    this.props.dispatch(
      setShowInviteTechnicianModal(true, UserModalState.READ_ONLY)
    );
  };

  handleResendInvite = (id) => {
    usersApi.resendInvite(id);
  };

  actionBtns(currentUser, user) {
    return (
      <div className="action-btns-wrapper">
        <span
          className="linkable action-btn"
          onClick={() => this.handleSelectUser(user)}
        >
          Edit
        </span>
        {usersApi.resendInviteLink(currentUser, user) ? (
          <span
            className="linkable action-btn"
            onClick={() => this.handleResendInvite(user.id)}
          >
            Resend Invite
          </span>
        ) : (
          ''
        )}
      </div>
    );
  }

  mapTechnicians = (technicians) => {
    const { currentUser } = this.props;

    return technicians.map((technician) => {
      return [
        <span className="h4">
          {technician.first_name} {technician.last_name}
        </span>,
        technician.email || 'N/A',
        technician.phone_number
          ? formatPhoneNumber(technician.phone_number)
          : 'N/A',
        this.actionBtns(currentUser, technician),
      ];
    });
  };
}

export default connect((state) => {
  return {
    technicians: getTechnicians(state),
    currentPageTechnicians: getCurrentPageTechnicians(state),
    perPageTechnicians: getPerPageTechnicians(state),
    totalTechnicians: getTotalTechnicians(state),
    activeTab: getActiveTab(state),
    currentUser: getCurrentUser(state),
  };
})(TechniciansTable);



// WEBPACK FOOTER //
// ./src/components/admin/team/TechniciansTable.js